import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime-corejs2/regenerator";
import _defineProperty from "/app/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import workerStatsByArg from "./common/workerStatsByArg";
import { prepareStats } from '@/modules/mm-utils';
import { lens } from '@/common/helpers';
import { API_REQUEST } from '@/api/';

function chunkArray(arr, chunkSize) {
  var chunks = [];

  for (var i = 0; i < arr.length; i += chunkSize) {
    chunks.push(arr.slice(i, i + chunkSize));
  }

  return chunks;
}

export default /*#__PURE__*/(function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, _ref2) {
    var commit, getters, rootGetters, from, to, _ref2$clearCache, clearCache, forceUpdate, employeeIds, promisesList, responses, workerStats, workerId, stats, plan, fact;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            commit = _ref.commit, getters = _ref.getters, rootGetters = _ref.rootGetters;
            from = _ref2.from, to = _ref2.to, _ref2$clearCache = _ref2.clearCache, clearCache = _ref2$clearCache === void 0 ? true : _ref2$clearCache, forceUpdate = _ref2.forceUpdate;

            if (!from) {
              from = getters['visibleDates'][0];
            }

            if (!to) {
              to = getters['visibleDates'].slice(-1)[0];
            }

            if (clearCache) {
              ['PLAN_APPR', 'PLAN_UNAPPR', 'FACT_APPR', 'FACT_UNAPPR'].forEach(function (el) {
                workerStatsByArg.purge(el);
              });
            }

            employeeIds = chunkArray(lens(getters.workers, 'employee_id'), 500);
            promisesList = employeeIds.map(function (item) {
              return API_REQUEST('getWorkerStats', {
                shop_id: rootGetters['queryMirrored/getOneDep'],
                forceUpdate: forceUpdate,
                dt_from: from,
                dt_to: to,
                employee_id__in: item.join()
              });
            });
            _context.next = 9;
            return Promise.allSettled(promisesList).then(function (res) {
              return res.map(function (item) {
                return item.value[1];
              });
            });

          case 9:
            responses = _context.sent;
            workerStats = responses.reduce(function (acc, val) {
              return _objectSpread(_objectSpread({}, acc), val);
            }, {}); // console.log(resultObj, 'resultObj')
            // const employeeIds = lens(getters.workers, 'employee_id')
            // const [, workerStats] = await API_REQUEST('getWorkerStats', {
            //   shop_id: rootGetters['queryMirrored/getOneDep'],
            //   forceUpdate,
            //   dt_from: from,
            //   dt_to: to,
            //   employee_id__in: employeeIds.join()
            // })
            // console.log(workerStats, 'workerStats')

            for (workerId in workerStats) {
              stats = workerStats[workerId];
              plan = stats.plan || {};
              fact = stats.fact || {};
              workerStatsByArg.set('PLAN_APPR', workerId, prepareStats(plan.approved));
              workerStatsByArg.set('PLAN_UNAPPR', workerId, prepareStats(plan.not_approved));
              workerStatsByArg.set('FACT_APPR', workerId, prepareStats(fact.approved));
              workerStatsByArg.set('FACT_UNAPPR', workerId, prepareStats(fact.not_approved));
              workerStatsByArg.setByWorkerId(workerId, stats);
            }

            commit('markUpdated', 'wStats');

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2) {
    return _ref3.apply(this, arguments);
  };
})();